import { Group } from './Group';
import {Customer} from './Customer';
import {Category} from './Category';
import {Type} from './Type';
import {Cidade} from './Cidade';
import {Comarca} from './Comarca'
import {Lotacao} from './Lotacao';

export class Cr {
    customer: Customer;
    category: Category;
    description: string;
    type: Type;
    z_alt_phone_number: string;
    cidade: Cidade;
    comarca: Comarca;
    lotacao: Lotacao;
    zs_email_preferencial: string;
    zs_oab: string;
    group: Group;

    constructor()

    constructor() {
        this.customer = new Customer();
        this.category = new Category();
        this.type = new Type();
        this.cidade = new Cidade();
        this.comarca = new Comarca();
        this.lotacao = new Lotacao();
        this.group = new Group();
    }
}